module.exports = __webpack_public_path__ + "static/media/demo4.97605026.png";